import { render, staticRenderFns } from "./Warehouses.vue?vue&type=template&id=2f100318&"
import script from "./Warehouses.vue?vue&type=script&lang=js&"
export * from "./Warehouses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports